import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTheme } from '@forma/forma-ui-theme';
import MainBanner7 from '@/components/blocks/MainBanner7';
import MetaTags from '@/components/MetaTags';
import useMetaTags from '@/hooks/useMetaTags';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';
import Cards2 from '@/components/blocks/Cards2';
import PriceAd from '@/components/blocks/PriceAd';
import Tariffs from '@/components/blocks/Tariffs';
import Service from '@/components/blocks/Service';
import Reviews2 from '@/components/blocks/Reviews2';
import WriteUs from '@/components/blocks/WriteUs';
import WidgetsSign from '@/components/blocks/WidgetsSign';
import { START_TARIFF_ID } from '@/data/constants';

import mockApi from '@/api/mockApi';
import tariffsApi from '@/api/tariffsApi';

export const getServerSideProps = async ({ req, res, params }) => {
  try {
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=14400, stale-while-revalidate=10'
    );
    const mainData = await mockApi.getMainData(params.locale);
    const pageData = await mockApi.getPromoData(params.locale, 'integrations/amo');
    const tariffsData = (await tariffsApi.getTariffs()).filter(tariff => tariff.id !== START_TARIFF_ID);

    const headersParse = await getHeadersFromServer(req);
    return {
      props: {
        initialState: {
          main: mainData,
        },
        page: pageData,
        tariffs: tariffsData,
        headersParse,
        ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
      },
    };
  } catch {
    return {
      notFound: true
    };
  }
};

const ContentPage = ({ page, tariffs }) => {
  const { t } = useTranslation();

  const metaData = {
    title: t('main_title'),
    description: t('main_description'),
    keywords: t('main_keywords'),
  };
  const { lang } = useTheme();
  useMetaTags({ lang, ...metaData });

  if (!page) return null;

  const { main_banner, automate, advestment, reviews, sign } = page;

  return (
    <div>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      <MainBanner7 {...main_banner} />
      <Cards2 {...automate} />
      <PriceAd {...advestment} />
      <Service href={main_banner.href} image="/images/integrations-amo.webp" />
      <Reviews2 {...reviews} />
      <WidgetsSign {...sign} />
      <Tariffs items={tariffs} columns={2} />
      <WriteUs />
    </div>
  );
};

export default ContentPage;
